import { IBookableDate, IBookableDatesInfo, IHoliday } from "./book.types";

export class BookableDatesInfo implements IBookableDatesInfo {
  bookableMonth: string;
  bookableDates: IBookableDate[];
  calendarWeekdays: string[];
  calendarHolidays: IHoliday[];
  calendar: string[][];

  constructor(data: IBookableDatesInfo) {
    this.bookableMonth = data.bookableMonth;
    this.bookableDates = data.bookableDates;
    this.calendarWeekdays = data.calendarWeekdays;
    this.calendarHolidays = data.calendarHolidays;
    this.calendar = data.calendar;
  }
}
